/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface FunnelEventBody {
    'surface': FunnelEventBodySurfaceEnum;
    'instance_id': string;
    'event_type': FunnelEventBodyEventTypeEnum;
    'placement'?: string | null;
    'lead'?: string | null;
    'variant'?: string | null;
    'detail'?: string | null;
}

export const FunnelEventBodySurfaceEnum = {
    ProPitch: 'pro_pitch',
    ProCard: 'pro_card',
} as const;

export type FunnelEventBodySurfaceEnum = typeof FunnelEventBodySurfaceEnum[keyof typeof FunnelEventBodySurfaceEnum];
export const FunnelEventBodyEventTypeEnum = {
    Shown: 'shown',
    NeedOpened: 'need_opened',
    GoPro: 'go_pro',
    LinkClicked: 'link_clicked',
    Closed: 'closed',
} as const;

export type FunnelEventBodyEventTypeEnum = typeof FunnelEventBodyEventTypeEnum[keyof typeof FunnelEventBodyEventTypeEnum];


